module.exports = __webpack_public_path__ + "static/media/selfie-incorrect.871aad49.png";